import { render, staticRenderFns } from "./CompletionByPosWidget.vue?vue&type=template&id=5c2124c5&scoped=true&"
import script from "./CompletionByPosWidget.vue?vue&type=script&lang=js&"
export * from "./CompletionByPosWidget.vue?vue&type=script&lang=js&"
import style0 from "./CompletionByPosWidget.vue?vue&type=style&index=0&id=5c2124c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2124c5",
  null
  
)

/* custom blocks */
import block0 from "./CompletionByPosWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardTitle,VIcon,VProgressCircular,VTooltip})
